// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2GJwF","wrapper-nopadding":"wrapper-nopadding__1VrzH","loading":"loading__2BT-p","error":"error__1KEeF","table-loading":"table-loading__dZk1U","empty-val":"empty-val__2kfTy","panelheader-tools":"panelheader-tools__3MvnM","propsPanels":"propsPanels__3fipf","new":"new__2nkWt","marginLm":"marginLm__3Vx37","marginRm":"marginRm__284bE","fullWidth":"fullWidth__puKnC","fullHeight":"fullHeight__3k55n","noData":"noData__26pf4","body":"body__3UVhp","name":"name__Tq9EJ","buttons":"buttons__2Njiw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/DeleteFlowModal/styles.scss
// module id = 2211
// module chunks = 1